<template>
  <div class="border-4 border-neutral-50 p-6">
    <KikHeading
      :level="3"
      title="Order as a Guest"
      description="Not ready to become a KiK customer yet?"
      class="mb-6 text-center"
    >
      <template #description="{ description }">
        <div class="mb-3 text-xs font-light leading-4 text-neutral-500">
          {{ $t(description) }}
        </div>
      </template>
    </KikHeading>
    <div class="grid grid-cols-1 gap-4">
      <KikButton
        class="w-full"
        variant="secondary"
        data-testid="btn__guest_order"
        :uppercase="true"
        @click="handleGuest"
      >
        {{ $t('Order as a Guest') }}
      </KikButton>
      <KikPaypalButton />
    </div>
    <KikLegalInformation class="mt-4" />
  </div>
</template>

<script setup lang="ts">
import { useCheckoutNavigation, UserType } from '~/composables/custom/useCheckoutNavigation/useCheckoutNavigation';

const { journey: { setUserType } } = useCheckoutNavigation();
const { closeLoginDrawer } = useUiState();

const handleGuest = () => {
  setUserType(UserType.ANONYMOUS);
  closeLoginDrawer();
  navigateTo({ name: 'billing-guest' });
};
</script>
